<template>
	<div
		class="statuses-floater"
		data-testid="module-status-item"
		:data-status-key="status.key"
	>
		<div class="nobr">
			<Badge :status="status.badge" />
			{{ $t('moduleStatuses.labels.' + status.key) }}
		</div>
		<div class="module-message" v-for="message in status.messages" :key="message.id">
			<div class="nobr">
				<AlertLevelDisplay :level="message.level" />
				<Tag v-if="message.tag.length > 0">{{ message.tag }}</Tag>
				<TypographyText type="secondary">{{ message.createdStr }} UTC</TypographyText>
			</div>
			<div class="module-message-text">
				{{ message.message }}
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import { Badge, TypographyText, Tag } from 'ant-design-vue';

import AlertLevelDisplay from '@/components/common/AlertLevelDisplay.vue';

import type { ModuleStatusDisplay } from '@/components/floaters/types/moduleStatusesTypes';


export default {
	components: {
		Badge, TypographyText, Tag, AlertLevelDisplay,
	},
	props: {
		status: {
			type: Object as PropType<ModuleStatusDisplay>,
			required: true,
		},
	},
}
</script>

<style scoped>
.module-message {
	max-width: 500px;
	font-size: 12px;
	padding-block-start: 8px;
	padding-inline-start: 24px;
}

.module-message-text {
	word-break: break-word;
}
</style>
